import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useSearchBarStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex'
    },

    hiddenBlock: {
      maxWidth: 350,
      [theme.breakpoints.down(960)]: {
        maxWidth: '100%',
        position: 'relative'
      }
    },

    sticky: {
      position: 'sticky',
      zIndex: 10,
      top: 80,
      maxWidth: 1390,
      width: '100%',
      margin: '0 auto',
      ['@media (max-width: 1290px)']: {
        maxWidth: 1200
      },
      ['@media (max-width: 1220px)']: {
        maxWidth: 1180
      }
    },

    button: {
      marginLeft: 32,
      display: 'flex',
      padding: '10px 37px',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },

    action: {
      cursor: 'pointer'
    },
    inputSearch: {
      background: '#FAFAFA',
      borderRadius: '13px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiOutlinedInput-inputMarginDense': {
        paddingTop: 12,
        paddingBottom: 12
      }
    },
    noBorder: {
      border: 'none!important',
      borderRadius: 0,
      [theme.breakpoints.down('xs')]: {
        boxShadow: 'none'
      }
    },
    dialogModal: {
      position: 'absolute',
      bottom: 'unset !important',
      left: 'unset !important',
      top: '124px !important',
      right: '0 !important',
      height: 'auto',
      width: '100%',
      overflow: 'hidden',
      padding: 0,
      backgroundColor: 'initial'
    },
    dialogContent: {
      backgroundColor: 'initial',
      padding: '25px 0px 0px 0px !important'
    },

    privateRequest: {
      display: 'flex',
      marginTop: 6,
      paddingBottom: 5,
      marginBottom: 20,
      width: '100%',
      minHeight: 35,
      overflowX: 'auto',
      overflowY: 'hidden',

      ['&::-webkit-scrollbar']: {
        height: '5px',
        borderRadius: '4px'
      },
      ['&::-webkit-scrollbar-track']: {
        backgroundColor: '#c9c9c9',
        borderRadius: '4px'
      },
      ['&::-webkit-scrollbar-thumb']: {
        backgroundColor: '#b5b3b3',
        borderRadius: '4px'
      },

      [theme.breakpoints.down(960)]: {
        marginBottom: 0,
        position: 'absolute',
        left: 0,
        bottom: '-38px',

        ['&::-webkit-scrollbar']: {
          height: 0,
          width: 0
        }
      }
    },

    privateRequestButton: {
      padding: 0,
      marginRight: 11,
      minWidth: 'auto',
      fontWeight: 400,
      fontSize: '12px',
      color: '#828282',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',

      ['&:last-child']: {
        marginRight: 0
      }
    }
  })
)
